import { apiCall } from "../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint) => apiCall("delete", endpoint);

export const getPaymentApi = async (params) => {
    try {
        return await get("get_payment_type", params);
    } catch (err) {
        console.error("Error fetching category:", err);
    }
};
export const getPurchaseListApi = async (params) => {
    try {
        return await get("purchase_order", params);
    } catch (err) {
        console.error("Error fetching category:", err);
    }
};

export const deletePoApi = async (id) => {
    try {
        return await del(`purchase_order/${id}`);
    } catch (err) {
        console.error("Error fetching category:", err);
    }
};

//view vendor details

export const getPOViewApi = async (id) => {
    try {
        return await get(`purchase_order/view/${id}`);
    } catch (err) {
        console.error("Error fetching category:", err); return err.response?.data ?? { success: false, message: err.message };
    }
}
export const getPODownloadApi = async (id) => {
    try {
        return await get(`purchase_order/pdf/${id}`);
    } catch (err) {
        console.error("Error fetching category:", err); return err.response?.data ?? { success: false, message: err.message };
    }
}

export const updateStatusApi = async (id, bodyData) => {
    try {
        const response = await put(`purchase_order/status_update/${id}`, bodyData);
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
        return err.response?.data ?? { success: false, message: err.message };
    }
};

